import { RootState } from '@iwProvider/configureStore';

export function getInitialDateFrom({ siteContext }: RootState) {
    // @ts-expect-error For some reason user_date_joined doesn't exist on the RootState for siteContext
    const dateJoined = siteContext.user_date_joined;
    return new Date(dateJoined).toISOString().substring(0, 10);
}

export function getInitialDateTo() {
    return new Date().toISOString().substring(0, 10);
}
